import { inject as inject$1, observer } from 'mobx-react';

var inject = (function (store_names) {
  return function (WrappedComponent) {
    return inject$1(function (stores, props) {
      if (typeof store_names === 'string') {
        store_names = [store_names];
      }

      if (store_names.length > 0) {
        store_names.forEach(function (store_name) {
          if (typeof props[store_name] !== 'undefined') {
            return;
          }

          if (typeof stores[store_name] !== 'undefined') {
            props[store_name] = stores[store_name];
          } else {
            props[store_name] = null;
          }
        });
      }

      return props;
    })(observer(WrappedComponent));
  };
});

export default inject;
//# sourceMappingURL=inject.js.map
